// #region Basket

// #region Coupon
function UseUserCoupon(CouponCode) {
    $.ajax({
        type: 'get',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        url: getRequestRoute() + "/p/CheckOutCart/AddCoupon?couponCode=" + CouponCode,
        async: true,
        beforeSend: function () {
            GenerateLocalLoading($(".OrderBasketContainerCouponCheck"), "show");
        },
        complete: function () {
            GenerateLocalLoading($(".OrderBasketContainerCouponCheck"), "hide");
        },
        success: function (dt) {
            if (dt.Status == true) {
                RefreshOrderSummary(true);
            }
            else {
                SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        }
    });
}

function DeleteUserCoupon() {
    $.ajax({
        type: 'post',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        url: getRequestRoute() + '/p/CheckOutCart/RemoveCoupon',
        beforeSend: function () {
            GenerateLocalLoading($(".OrderBasketContainerCouponCheck"), "show");
        },
        complete: function () {
            GenerateLocalLoading($(".OrderBasketContainerCouponCheck"), "hide");
        },
        success: function (dt) {
            if (dt.Status == true) {
                RefreshOrderSummary(true);
            }
            else {
                SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        }
    });
}
// #endregion

// #region GiftPackage
function SetGift(wantGift, callback) {
    $.ajax({
        type: 'POST',
        url: getRequestRoute() + "/p/CheckoutCart/SetGift?wantGift=" + wantGift,
        cache: false,
        async: false,
        success: function (dt) {
            if (dt.Status == true) {
                RefreshOrderSummary(true);
                callback(wantGift);
            }
            else {
                SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                callback(false);
            }
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            callback(false);
        }
    });
}

function GiftPackageControl() {
    var wantGift = $("#GiftPackageChk").prop("checked");

    if (wantGift == true) {
        SetGift(wantGift);
    }
}
// #endregion

// #region BasketItems
function UpdateCartAmount(BasketID, Amount, LangID, callback) {
    GenerateLocalLoading($(".OrderBasketContainer"), "show");

    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/UpdateCartAmount",
        data: 'id=' + BasketID + "&adet=" + Amount + "&langID=" + LangID,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        cahce: false,
        async: true,
        success: function (dt) {
            callback(dt.Sonuc, dt.IslemSonucAciklama);
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}

function RemoveFromCart(BasketID, LangID) {
    GenerateLocalLoading($(".OrderBasketContainer"), "show");

    $.ajax({
        type: 'GET',
        url: getRequestRoute() + '/p/Cart/RemoveFromCart',
        data: 'id=' + BasketID + "&langID=" + LangID,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        success: function (dt) {
            if (dt.Sonuc == true) {
                GetBasketItems();
                GiftPackageControl();
                RefreshOrderSummary();
            }
            else {
                GenerateLocalLoading($(".OrderBasketContainer"), "hide");
                SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            GenerateLocalLoading($(".OrderBasketContainer"), "hide");
        }
    });
}

function GetBasketItems() {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + '/p/Checkout/sepet',
        dataType: 'html',
        cache: false,
        async: false,
        success: function (dt) {
            GenerateLocalLoading($(".OrderBasketContainer"), "hide");
            $(".OrderBasketContainer").html(dt);
        },
        error: function (dt) {
            GenerateLocalLoading($(".OrderBasketContainer"), "hide");
        }
    });
}
// #endregion

// #endregion

// #region LoginRegisterModal
function SetMemberless() {
    GenerateLocalLoading($("#LoginRegisterModal .modal-dialog"), "show");

    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/CheckoutValidation/SetMemberless?memberless=true",
        cache: false,
        success: function (dt) {
            if (dt.Status == true) {
                SetStep("adres");
            }
            else {
                SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                GenerateLocalLoading($("#LoginRegisterModal .modal-dialog"), "hide");
            }
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            GenerateLocalLoading($("#LoginRegisterModal .modal-dialog"), "hide");
        }
    });
}

function LoginRegisterFormSubmit(form) {
    GenerateLocalLoading($("#LoginRegisterModal .modal-dialog .modal-content"), "show");
    
    $.ajax({
        type: "POST",
        url: form.attr("action"),
        data: form.serialize(),
        dataType: "json",
        success: function (dt) {
            if (dt.Sonuc == true) {
                if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                    document.location = $("#register_FbRedirectUrl").val();
                }

                if (dt.JsonRs == "Reload" || dt.JsonRs == "Redirect") {
                    document.location = dt.Deger5;

                }
                else {
                    SwalGenerate("success", dt.IslemSonucAciklama, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
                    GenerateLocalLoading($("#LoginRegisterModal .modal-dialog .modal-content"), "hide");

                    $("#LoginRegisterModal .ForgettenForm").trigger("reset");
                    $("#LoginRegisterModal .ForgettenForm .btn-cancel").trigger("click");
                }
            }
            else {
                SwalGenerate("error", dt.IslemSonucAciklama, dt.Deger8/*getStandartMessages("GirisHata")*/, getStandartMessages("TekrarDene"));
                GenerateLocalLoading($("#LoginRegisterModal .modal-dialog"), "hide");
            }
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("GirisHata"), getStandartMessages("TekrarDene"));
            GenerateLocalLoading($("#LoginRegisterModal .modal-dialog .modal-content"), "hide");
        }
    });
}

// #endregion

// #region Address
function GetPartialAdress(AddressModal, EditLink) {
    if (EditLink == "" || EditLink == null || EditLink == undefined) {
        EditLink = getRequestRoute() + "/p/CheckOutAddress/EditOrCreate";
        AddressModal.find(".modal-header > .edit").hide();
        AddressModal.find(".modal-header > .create").show();
    }
    else {
        AddressModal.find(".modal-header > .edit").show();
        AddressModal.find(".modal-header > .create").hide();
    }

    $.ajax({
        type: "GET",
        url: EditLink,
        success: function (data) {
            AddressModal.find(".modal-body").html(data);

            if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "TR"
                || $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "KKTC") { // TR
                $(".tr_group").show();
                $(".stateDiv").hide();
                $(".cityDiv").hide();
            }

            if (($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "TR"
                &&
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "KKTC")
                &&
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "CA"
                &&
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "US") { //Rest of world

                $(".tr_group").hide();
                $(".stateDiv").hide();
                $(".cityDiv").show();
            }

            if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "CA"
                ||
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "US") { //USA & CA

                $(".tr_group").hide();
                $(".stateDiv").show();
                $(".cityDiv").show();
            }

            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            AddressModal.modal("hide");
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
        }
    });
}

function GetAddressList() {
    GenerateLocalLoading($(".OrderContentDetails"), "show");

    $.ajax({
        type: 'GET',
        url: getRequestRoute() + '/p/Checkout/adres',
        success: function (data) {
            $(".OrderContentDetails .MyAddress").html(data);
            GenerateLocalLoading($(".OrderContentDetails"), "hide");
        },
        error: function () {
            GenerateLocalLoading($(".OrderContentDetails"), "hide");
        }
    });
}

function GetDistrict(CityID) {
    AddressModal = $("#AddressAddModal");
    GenerateLocalLoading(AddressModal.find(".modal-dialog"), "show");

    $.ajax({
        type: 'GET',
        url: getRequestRoute() + '/p/User/GetTowns',
        data: 'cityid=' + CityID,
        dataType: 'json',
        success: function (dt) {
            $('#AddressAddModal #TownID option').remove();

            $('#AddressAddModal #TownID')
                .append($("<option selected='selected' ></option>")
                    .attr("value", "")
                    .text("Lütfen Seçin"));


            $('#AddressAddModal #TownID').parent().find("span").html("Lütfen Seçin");

            for (var i = 0; i < dt.length; i++) {

                $('#AddressAddModal  #TownID')
                    .append($("<option></option>")
                        .attr("value", dt[i].ID)
                        .text(dt[i].Name));
            }

            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
        },
        error: function () {
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        }
    });
}

function DeleteAddress(AddressID, AddressBox) {
    var DeleteUrl = getRequestRoute() + "/p/CheckoutAddress/Delete?adresid=" + AddressID;
    GenerateLocalLoading(AddressBox, "show");

    $.ajax({
        type: "POST",
        url: DeleteUrl,
        cache: false,
        success: function (data) {
            if (data.Status == true) {
                SwalGenerate("success", getStandartMessages("AdresSilindi"), getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
                GetAddressList();
            }
            else {
                SwalGenerate("error", data.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }

            GenerateLocalLoading(AddressBox, "hide");
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            GenerateLocalLoading(AddressBox, "hide");
        }
    });
}

function AddAddress(form) {
    $.ajax({
        type: form.attr("method"),
        url: getRequestRoute() + '/p/CheckoutAddress/EditOrCreate',
        data: form.serialize(),
        dataType: 'json',
        success: function (data) {
            if (data.Status == true) {
                $("#AddressAddModal").modal("hide");
                GetAddressList();

                RefreshOrderSummary(false);

                SwalGenerate("success", data.ResultDescription, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
            }
            else {
                SwalGenerate("error", data.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }

            GenerateLocalLoading(form, "hide");
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            GenerateLocalLoading(form, "hide");
        }
    });
}

function SetAddress(id, addressType, isAllSelected) {
    if (id != null && id != "" && id != "" && id > 0) {
        GenerateLocalLoading($(".OrderContentDetails"), "show");

        $.ajax({
            type: 'POST',
            url: getRequestRoute() + "/p/CheckOutAddress/SetAddress?addressID=" + id + "&addressType=" + addressType + "&UpdateAllAddress=" + isAllSelected,
            cache: false,
            success: function (dt) {
                ReloadOnTimeOut();
                GenerateLocalLoading($(".OrderContentDetails"), "hide");

                if (dt.Status) {
                    RefreshOrderSummary(false);
                    RefreshCargoList();
                }
                else {
                    if (dt.StatusText == "InvalidAddress") {
                        AddressModal = $("#AddressAddModal");
                        AddressModal.modal("show");
                        ModalHideEvent(AddressModal, ".modal-body");
                        GenerateLocalLoading(AddressModal.find(".modal-dialog"), "show");

                        var EditUrl = getRequestRoute() + "/p/CheckOutAddress/EditOrCreate?id=" + id;
                        GetPartialAdress(AddressModal, EditUrl);
                    }

                    SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));

                    $(".AddressContainer .CustomCheckbox").removeClass("selected");

                    $(".AddressContainer .CustomCheckbox input").prop("checked", false);
                    $(".AddressContainer .CustomCheckbox label").removeClass("c_on");

                    oldSelect.addClass("selected");
                    oldSelect.find("input").prop("checked", true);
                    oldSelect.find("label").addClass("c_on");
                }
            },
            error: function () {
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                GenerateLocalLoading($(".OrderContentDetails"), "hide");
            }
        });
    }
}

function SetCargoPrice(id) {
    CargoListContainer = $("#CargoList");
    GenerateLocalLoading(CargoListContainer, "show");

    if (id == null || id == "" || id == undefined) {
        id = $("#CargoTable tbody tr td label input:first").val();
    }

    $.ajax({
        type: 'post',
        url: getRequestRoute() + "/p/CheckoutAddress/SetCargoPrice?cargoPriceID=" + id,
        success: function (dt) {
            ReloadOnTimeOut();

            if (dt.Status == true) {
                RefreshOrderSummary();
                selectedCargoPriceID = id;

                $("#CargoTable tr td label input").prop("checked", false);
                $("#CargoTable tr td label input[value=" + id + "]").prop("checked", true);

                GenerateLocalLoading(CargoListContainer, "hide");
            }
            else {
                GenerateLocalLoading(CargoListContainer, "hide");

                $(".OrderContentDetails .AddressContainer .AddressBox.NewAddress").trigger("click");
            }
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            GenerateLocalLoading(CargoListContainer, "hide");
        }
    });
}

function RefreshCargoList() {
    $.ajax({
        type: 'GET',
        cache: false,
        async: true,
        url: getRequestRoute() + "/p/CheckOutAddress/GetCargoList",
        success: function (dt) {
            $("#CargoList").html(dt);
        }
    });
}
// #endregion

// #region Payment
function SetAgreement(IsApproved) {
    if (IsApproved == true || IsApproved == false) {
        $.ajax({
            type: 'POST',
            url: getRequestRoute() + "/p/CheckoutPayment/SetAgreement?isApproved=" + IsApproved,
            cache: false,
            async: true,
            success: function (dt) {
                ReloadOnTimeOut();

                if (dt.Status == true) {
                    RefreshOrderSummary();
                }
                else {
                    SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }
            },
            error: function () {
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        });
    }
}

function PaymentButtonControl() {
    if ($("#CurStep").val() == "Odeme") {
        if ($("#OrderSummary .SummaryAgrement .CustomCheckbox").hasClass("selected") && $("#PaymentAccordion .panel-collapse").hasClass("show")) {
            if ($("#PaymentAccordion .panel-collapse.show .PaymentDetail").hasClass("OnlinePos")) {
                if ($("#PaymentAccordion .panel-collapse.show .PaymentDetail.OnlinePos #CardForm .cardType").hasClass("Valid")) {
                    $("#SummaryNextBackButtons #nextbtn").removeAttr("disabled");
                }
                else {
                    $("#SummaryNextBackButtons #nextbtn").prop("disabled", "true");
                }
            }
            else {
                $("#SummaryNextBackButtons #nextbtn").removeAttr("disabled");
            }
        }
        else {
            $("#SummaryNextBackButtons #nextbtn").prop("disabled", "true");
        }
    }
}

function SetPaymentType(webPosInstallmentID, BankID) {
    if (BankID == undefined) { BankID = 0; }

    $.ajax({
        type: 'POST',
        url: getRequestRoute() + "/p/CheckOutPayment/SetPaymentType?webPosInstallmentID=" + webPosInstallmentID + "&bankID=" + BankID,
        cache: false,
        success: function (dt) {
            ReloadOnTimeOut();

            if (dt.Status) {
                RefreshOrderSummary(false);
            }
            else {
                SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        }
    });
}

function SetPayAtDoorType(id) {
    if (id != null && id != "" && id != undefined && id > 0) {
        $.ajax({
            type: 'POST',
            url: getRequestRoute() + "/p/CheckoutPayment/SetPayAtDoorType?kapidaOdemeTuru=" + id,
            cache: false,
            success: function (dt) {
                ReloadOnTimeOut();

                if (dt.Status == true) {
                    RefreshOrderSummary();
                }
                else {
                    SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }
            },
            error: function () {
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        });
    }
    else {
        SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
    }
}

// #region Credit Card
function CheckBinNumber() {
    var t_1 = $("#CardNumbers input#CardNumber1").val().replace(/\D/g, '');
    var t = t_1;

    if (t.length >= 6) {

        var tval6 = t.substring(0, 6);
        lastBin = tval6;

        if (lastBin != firstBin) {
            GetCardDetails(tval6);

            firstBin = lastBin;
        }
    }
}

function GetCardDetails(BinNo) {
    if (BinNo != null && BinNo != "" && BinNo != undefined && BinNo.length == 6) {

        $.ajax({
            type: 'GET',
            url: getRequestRoute() + "/p/CheckoutPayment/CardDetails",
            dataType: 'json',
            async: true,
            data: "BinNo=" + BinNo,
            success: function (jsonReturn) {
                if (jsonReturn.length !== 0) {

                    $.each(jsonReturn, function (index, element) {

                        var bnkCode = element.BankCode;
                        var cardType = element.CardType;
                        var cardName = element.CardName;
                        var installmentCount = element.InstallmentCount;

                        ShowInstallments(bnkCode, cardType, cardName, installmentCount);
                    });
                }
                else {
                    ShowInstallments(-1, "CREDIT_CARD");
                }
            }
        });
    }
}

function ShowInstallments(bankCode, cardType, CardName, installmentCount) {

    if (bankCode != -1) {

        var activeCls = "";

        switch (cardType) {
            case "CREDIT_CARD":
                activeCls = "KrediKarti";
                break;
            case "DEBIT_CARD":
                activeCls = "DebitCard";
                break;
        }

        var cardown = $("#CardOwner:first").val();
        var isAmex = false;
        var isShopAndMiles = false;

        if (CardName != null && CardName != "" && CardName != undefined && CardName.length > 0) {

            if (CardName.toUpperCase().indexOf("AMEX") > -1) {
                isAmex = true;
            }

            if (CardName.toUpperCase().indexOf("MASTER SM") > -1 || CardName.toUpperCase().indexOf("VISA SM") > -1) {
                isShopAndMiles = true;
            }
        }

        if (isAmex || isShopAndMiles) bankCode = "64"; //burda hangi banka gelmeli belirlenmeli

        InstallmentRows = $("#creditcard .Installments table tbody tr");
        InstallmentRows.removeClass("IsPasive").removeClass("IsActive");
        InstallmentRows.addClass("IsPasive");

        //alert("cardType: " + cardType);
        //alert("installmentCount: " + installmentCount);

        //banka kartı tek çekim olarak gösterilecektir.
        if (cardType == "DEBIT_CARD") {

            InstallmentRows.removeClass("IsActive");
            InstallmentRows.addClass("IsPasive");

            $(".DefaultInstallment").removeClass("IsPasive");
            $(".DefaultInstallment").addClass("IsActive");

            InstallmentRows.first().trigger("click");
        }

        //kredi kartı tek çekim olanları gösterecek.
        if (cardType == "CREDIT_CARD" && installmentCount == 1) {

            InstallmentRows.removeClass("IsActive");
            InstallmentRows.addClass("IsPasive");

            $(".DefaultInstallment").removeClass("IsPasive");
            $(".DefaultInstallment").addClass("IsActive");

            InstallmentRows.first().trigger("click");
        }

        //kredi kartı tüm taksitleri gösterecek.
        else if (cardType == "CREDIT_CARD") {
            InstallmentRows.removeClass("IsPasive");
            InstallmentRows.addClass("IsActive");

            InstallmentRows.first().trigger("click");
        }

        else if (cardown == "BÜTÜN POSLAR") {
            InstallmentRows.removeClass("IsPasive");
            InstallmentRows.addClass("IsActive");

            InstallmentRows.first().trigger("click");
        }

        //herhangi bir durumda default pos taksit (Tek çekim) gösterilecektir.
        else {
            InstallmentRows.removeClass("IsActive");
            InstallmentRows.addClass("IsPasive");

            $(".DefaultInstallment").removeClass("IsPasive");
            $(".DefaultInstallment").addClass("IsActive");

            InstallmentRows.first().trigger("click");
        }
    }
}
// #endregion

// #endregion

function PrepareAddressAndPayment(curStep) {
    if (curStep != null && curStep != "" && curStep != undefined) {
        var url = "";

        if (curStep == "Sepet") {
            url = getRequestRoute() + "/p/CheckOutAddress/PrepareUserAdresses";
        }
        else if (curStep == "Adres") {
            url = getRequestRoute() + "/p/CheckOutPayment/PreparePayment";
        }

        if (url.length > 0) {
            $.ajax({
                type: 'POST',
                url: url,
                success: function (dt) {
                }
            });
        }
    }
}

function SetStep(adim) {
    GenerateLocalLoading($("#OrderDetailArea"), "show");

    var OrdGiftNote = "";
    if ($("#OrderNoteText").length > 0) {
        OrdGiftNote += "OrderNote=" + $("#OrderNoteText").val();
    }

    if ($("#OrderGiftNoteText").length > 0) {
        OrdGiftNote += "&GiftNote=" + $("#OrderGiftNoteText").val();
    }

    $.ajax({
        type: 'POST',
        cache: false,
        url: getRequestRoute() + "/p/CheckoutValidation/SetStep?step=" + adim,
        data: OrdGiftNote,
        success: function (dt) {
            ReloadOnTimeOut();

            if (dt.Status == false) {
                if (dt.StatusText == "AskForLogin") {
                    $("#LoginRegisterModal .LoginPanel").show();
                    $("#LoginRegisterModal .RegisterPanel").hide();
                    $("#LoginRegisterModal").modal("show");
                }
                else if (dt.StatusText == "MissingAddress" || dt.StatusText == "InvalidAddress" || dt.StatusText == "TcknRequired") {

                    if ($("#CurStep").val() == "Adres") {
                        //var idValue = 0;

                        //if (dt.StatusText == "TcknRequired") {
                        //    idValue = parseInt($("#addressID").val());
                        //}

                        //if (dt.Result !== null && dt.Result !== undefined && dt.Result !== "") {
                        //    idValue = dt.Result;
                        //}

                        //if (idValue != null && idValue != "" && idValue != undefined && idValue > 0) {
                        //    AddressModal = $("#AddressAddModal");

                        //    AddressModal.modal("show");
                        //    ModalHideEvent(AddressModal, ".modal-body");
                        //    GenerateLocalLoading(AddressModal.find(".modal-dialog"), "show");

                        //    var url = getRequestRoute() + "/p/CheckOutAddress/EditOrCreate?id=" + idValue;

                        //    GetPartialAdress(AddressModal, url);
                        //    if (dt.StatusText == "TcknRequired") {
                        //        SwalGenerate("", dt.ResultDescription, getStandartMessages("Eksik Bilgi"), getStandartMessages("TekrarDene"));
                        //    }
                        //}
                        //else {
                        //    $(".MyAddress .AddressContainer .AddressBox.NewAddress").trigger("click");
                        //}

                        $(".MyAddress .AddressContainer .NewAddress").trigger("click");
                    }
                    else {
                        SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                    }
                }
                else {
                    SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }

                GenerateLocalLoading($("#OrderDetailArea"), "hide");
            }

            if (dt.Status == true) {
                // Hata yoksa ve progress ise bekleyinizi göster
                if (adim == "progress") {
                    $(".SummaryContainer #nextbtn").text($("#PleaseWait").val());
                }

                // goto next step
                document.location.href = getRequestRoute() + "/p/CheckOut/" + adim;
            }
        }
    });
}

function SetCreditCartAndStep(adim) {
    if ($("#CardForm").length > 0) {
        GenerateLocalLoading($("#OrderDetailArea"), "show");
        form = $("#CardForm");

        $.ajax({
            type: 'POST',
            async: true,
            cache: false,
            url: getRequestRoute() + "/p/CheckoutPayment/SetCreditCard",
            data: form.serialize(),
            success: function (dt) {
                ReloadOnTimeOut();

                if (dt.Status == true) {
                    SetStep(adim);
                }
                else {
                    SwalGenerate("error", dt.ResultDescription, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                    GenerateLocalLoading($("#OrderDetailArea"), "hide");
                }
            },
            error: function () {
                GenerateLocalLoading($("#OrderDetailArea"), "hide");
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        });
    }
}

function RefreshOrderSummary(animateTop) {
    GenerateLocalLoading($("#OrderSummary"), "show");

    $.ajax({
        type: 'GET',
        cache: false,
        url: getRequestRoute() + "/p/CheckOut/summary",
        success: function (dt) {
            $("#OrderSummary").html(dt);

            GenerateLocalLoading($(".SummaryContainer"), "hide");
            PaymentButtonControl();

            //if (animateTop && !isMobileResolution()) {
            //    $('html,body').animate({ scrollTop: 2000 }, 'slow', function () { });
            //}
        },
        error: function () {
            GenerateLocalLoading($(".SummaryContainer"), "hide");
        }
    });
}



//favorilere ekleme ve silme
function AddToFavorite(ColorID, ProductID, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/AddToFollowList",
        data: 'colorID=' + ColorID + "&productID=" + ProductID,
        dataType: 'json',
        async: true,
        success: function (dt) {
            if (dt.Sonuc == true) {
                GetSepetIcerik(function (dt) {
                    $("#UserAndBasket").html(dt);
                    //generateToolTip();
                });
                callback(true, "");
            }
            else {
                callback(false, getStandartMessages("FavorilerIcinGirisYapin"));
            }
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });

}

function removeFavorite(ProductID, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/RemoveFromList",
        data: 'id=' + ProductID + "&IsDetail=true",
        dataType: 'json',
        async: true,
        success: function (dt) {
            if (dt.Sonuc == true) {
                GetSepetIcerik(function (dt) {
                    $("#UserAndBasket").html(dt);
                    // generateToolTip();
                });
                callback(true,"");
            }
        },
        error: function () {
            callback(false);
        }
    });
}